module.exports = __webpack_public_path__ + "static/media/edit-packet-title.408feb64.png";